import css from '@emotion/css';
import styled from '@emotion/styled';

export const StyledStepNumber = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  color: ${(props) =>
    props.active ? 'white' : 'var(--color-font-placeholder)'};
  background-color: ${(props) =>
    props.active
      ? 'var(--color-button-secondary-default)'
      : 'var(--color-button-disabled-default)'};
  margin-right: 50px;
  font-size: 11px;
`;

export const StyledStepHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledSpaceBetween = styled.div`
  display: flex;
  align-items: start;
  ${({ gap }) => (gap ? `gap: ${gap}px;` : '')}
  ${({ top }) => (top ? `padding-top: ${top}px;` : '')}
`;

export const StyledRightAlignedField = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
`;

export const StyledProgress = styled.div`
  margin-right: 50px;
  display: flex;
  justify-content: center;
`;

export const StyledProgressLine = styled.div`
  width: 1px;
  border-right: 1px solid
    ${(props) =>
      props.active
        ? 'var(--color-button-secondary-default)'
        : 'var(--color-button-disabled-default)'};
`;

export const StyledModalSection = styled.div`
  margin-top: 10px;
  margin-bottom: 40px;
  ${({ last }) => (last ? `margin-bottom: 2px;` : '')}
  & p {
    margin-bottom: 10px;
  }
`;

export const StyledWizardParagraph = styled.p`
  font-size: 14px;
  padding-top: ${(props) => (typeof props.top === 'number' ? props.top : 25)}px;

  ${({ disabled }) =>
    disabled
      ? css`
          font-style: italic;
        `
      : ''}
`;

export const StyledWizardBody = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  margin: 15px 20px 0px;

  .modal-select,
  .modal-select > div {
    width: 100%;
    max-width: 100%;
  }
  .modal-select > div {
    margin-top: 15px;
  }
  .modal-radio .entity.child {
    max-height: 100px;
  }
  .modal-frequency,
  .modal-frequency label,
  .modal-frequency .child {
    max-height: 35px;
  }
`;

export const MetaFilterSummaryWrapper = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const StyledWizardField = styled.div`
  ${({ flex }) => (flex ? '' : 'max-width: 600px;')}
  ${({ fullWidth }) => (fullWidth ? 'width: 100%;' : '')}
  padding-top: ${(props) => (typeof props.top === 'number' ? props.top : 25)}px;

  .wizard-buttons {
    display: flex;
    width: 100%;
  }

  .wizard-buttons button {
    border-radius: 4px;
  }

  .modal-select > div {
    margin-top: 0;
  }

  .modal-select {
    margin-top: 16px;
  }

  .lead-sources__menu-notice--loading {
    font-size: 1.4em;
  }

  ${({ marginTop }) =>
    typeof marginTop === 'number'
      ? css`
          margin-top: ${marginTop}px;
        `
      : ''}

  ${({ gap }) =>
    gap
      ? css`
          gap: ${gap}px;
          display: flex;
          flex-direction: column;
        `
      : ''}
`;

export const StyledHistorySwitch = styled.div`
  display: flex;
  align-items: center;

  .history-switch {
    margin-left: ${({ left }) => (typeof left === 'number' ? left : 10)}px;
  }
`;

export const ChartSelectionWrapper = styled.div`
  display: flex;
  gap: 0 ${({ mobile }) => (mobile ? 10 : 15)}px;
  width: 100%;

  && div.chartType.child {
    padding: 0;
    padding-bottom: 15px;
    user-select: none;
  }

  && div.chartType.child p {
    margin-top: 2px;
    font-size: 1.1em;
  }

  && div.chartType.child img {
    user-select: none;
    -webkit-user-drag: none;
  }

  & > label {
    // We have to do a bit of complicated math here to get the chart selector to line up
    // well with the buttons in other wizard sections. The +5px is a fixed offset to make sure
    // each button lines up in a vertical line.
    ${({ mobile }) => css`
      max-width: calc(${100 / (mobile ? 2 : 4)}% - ${mobile ? 5 : 10}px);
    `}
  }
`;
